export const KANGURO_API_PROXY = '/api/v1'
export const KANGURO_INTEGRATED_API_PROXY = '/api/v2'
export const APP_API_PROXY = '/api/app'

export const API_PATH = {
  KEYCLOAK: '/keycloack',
  USER_ACCOUNT: '/user/UserAccount',
  PETS: '/pets',
  POLICY: '/policy',
  BANKS: '/banks',
  USER: '/user',
  RENTERS_POLICY: '/renters/policy',
  USER_PREFERENCES: '/user/userPreferences',
  VALIDATE_ONBOARDING: '/user/validateOnboarding',
  PET_BREEDS: '/breeds',
  ADDITIONAL_PARTIES_NOTIFY: '/AdditionalParties/notify',
  PET_VETS: '/pets/vets',
  TEMPORARY_FILE: '/TemporaryFile',
  TEMPORARY_FILE_UPLOAD_URL: '/TemporaryFile/UploadUrl',
  TELEVET_EMBEDDED_LINK: '/televet/generateEmbeddedLink',
  RENTERS_CLAIMS: '/directus/items/renters_claims',
  DIRECTUS_FILES: '/directus/files',
  UPDATE_USER_PROFILE: '/user/updateUserProfile',
} as const

export const API_V2_PATH = {
  USER: '/user',
  // Create and update are pet-specific; submit, lists and documents are shared
  PET_CLAIMS: '/pet/claims',
  CLAIMS: '/claims',
  CLAIM_DOCUMENTS: '/documents',
} as const

export const API_APP_PATH = {
  ONBOARDING: '/onboarding',
  PET_ADDITIONAL_PARTY: '/pet-additional-party',
} as const

export const HTTP_STATUS = {
  NOT_FOUND: 404,
  CONFLICT: 409,
  PAYLOAD_TOO_LARGE: 413,
  UNSUPPORTED_MEDIA_TYPE: 415,
  UNPROCESSABLE: 422,
} as const
